import React, { useState, useEffect, useRef } from 'react';
import * as actions from '../../pages/laudo/etapas/material/material.action';
import '../_util/icons/mv-basico/css/mv-basico.old.css';
import {
	removeUsuarioLocalStorage,
	removeTokenLocalStorage,
	getUsuarioLocalStorage,
	removeUrlEditorLocalStorage,
	getTokenLocalStorage
} from '../../localStorage.util';
import WebapiCommon from '../../app/common/util/webapi.common';
import MensagensContainer from '../../app/common/mensagens/mensagens.container';
import * as commonActions from '../../app/common/common.action';
import * as certificacaoActions from '../../app/common/certificacao/certificacao.action';
import * as descarteActions from '../../pages/descarte/common/store/descarte.action';
import DescarteApi from '../../pages/descarte/descarte.api';
import { acessoPermitido } from '../../acessos.seguranca';
import * as acessos from '../../acessos.const.util';
import { GetNavIcones } from './navIcones';
import store from '../../configureStore.util';
import Logo from '../../assets/logo-anatomia.png';
import NavComponent from '../../componentes/navbar/nav.component';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Badge, Button, Col, Input } from 'reactstrap';
import { UncontrolledTooltip } from 'reactstrap/lib/Uncontrolled';
import { useDispatch, useSelector } from 'react-redux';
import ModalCertificacao from '@componentes/modalCertificacao';
import FormsValues from '@constants/defaultForms';
import { homolog, carregarDadosEditorLocalStorage } from '@constants/defaultValues';
import { injectIntl } from 'react-intl';
import * as usuarioActions from '@common/usuario/usuario.action';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Button as PrimeButton } from 'primereact/button';
import { Colxx, Separator } from '@common/customBootstrap';
import classNames from 'classnames';
import Select from 'react-select';
import Row from 'reactstrap/lib/Row';
import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.css';
import ConfiguracaoApi from '../../pages/configuracao/configuracao.api';
import IntlMessage from '../../helpers/intlMessage';
import './nav.styles.css';
import { changePeriod, getDate } from '../../helpers';
import DatePicker, { registerLocale } from 'react-datepicker';
import en from 'date-fns/locale/en-US';
import es from 'date-fns/locale/es';
import pt from 'date-fns/locale/pt-BR';
import ModalNovoPedido from '@componentes/modalNovoPedido';
import LoginApi from '../../pages/login/login.api';
import authProvider from '../../helpers/authProvider';
import { httpRequest } from '@util/api-common.util';

registerLocale('pt-br', pt);
registerLocale('es', es);
registerLocale('en', en);

const TopNav = (props) => {
	const [usuario, setUsuario] = useState(null);
	const [navIcones, setNavIcones] = useState([]);
	const [serviceAgreement, setServiceAgreement] = useState([]);
	const [countAcordo, setCountAcordo] = useState(0);
	const [selectedServiceAgreement, setSelectedServiceAgreement] = useState([]);
	const [selectedData, setSelectedData] = useState();
	const [selectedDataVencimento, setSelectedDataVencimento] = useState();
	const [scrolled, setScrolled] = useState();
	const [linkSoul, setLinkSoul] = useState();
	const [openModalNovoPedido, setOpenModalNovoPedido] = useState(false);
	const [selectedStatus, setSelectedStatus] = useState(null);
	const periods = FormsValues('periodos_full');
	const paginaCertificado = useSelector((state) => state.certificacao.pagina);
	const listaCertificadosPendentes = useSelector(
		(state) => state.certificacao.listaPendentes
	);
	const certificadosSelecionados = useSelector(
		(state) => state.certificacao.certificadosSelecionados
	);
	const listagemExibido = useSelector(
		(state) => state.certificacao.listaExibido
	);
	const modalCertificacaoDigital = useSelector(
		(state) => state.certificacao.showModal
	);
	const totalCertificadosPendentes = useSelector(
		(state) => state.certificacao.totalPendentes
	);
	const currentUser = useSelector((state) => state.usuario);
	const detalhes = useSelector((state) => state.commonReducer.detalhes);
	const collapsed = useSelector(
		(state) => state.recebimentoMaterial.collapsedMenu
	);

	const modalMensagens = useSelector(
		(state) => state.commonReducer.modalMensagens
	);
	const currentTotalMateriaisavencer = useSelector(
		(state) => state.descarteCommon.totalMateriaisavencer
	);
	const modalSoul = useSelector((state) => state.commonReducer.modalSoul);
	const dispatch = useDispatch();
	const op = useRef(null);
	const soul = useRef(null);
	const refServiceAgreement = useRef(null);
	const dateRef = useRef();
	const dt = useRef();
	const hml = homolog;
	const { messages } = props.intl;
	authProvider.call();

	useEffect(() => {
		httpRequest('AcordoAtendimento/Listar', 'GET').then((data) => {
			setServiceAgreement(data.data);
			setCountAcordo(data.totalItems);
		});
	}, []);

	carregarDadosEditorLocalStorage();

	const header = () => {
		return (
			<div>
				List of Customers
				<div className="p-datatable-globalfilter-container">
					<InputText
						type="search"
						onInput={(e) => setGlobalFilter(e.target.value)}
						placeholder="Global Search"
					/>
				</div>
			</div>
		);
	};

	function userVerify() {
		const payload = getUsuarioLocalStorage();
		dispatch(usuarioActions.atualizarUsuario(payload));
		return payload;
	}

	function resetPendentes() {
		dispatch(certificacaoActions.certificadosSelecionados([]));
		dispatch(certificacaoActions.listaPendentes([]));
		dispatch(certificacaoActions.listaExibido(0));
		dispatch(certificacaoActions.pagina(1));
		resetCertificadosPendentes();
		setScrolled(false);
	}

	function logout() {
		LoginApi.logout();
		store.dispatch({ type: 'RESET' });
		removeUsuarioLocalStorage();
		removeTokenLocalStorage();
		removeUrlEditorLocalStorage();
		props.history.push('/login');
	}

	function verificaPermissao(payload) {
		ConfiguracaoApi.getConfiguracaoGeral().then((res) => {
			const mudarStatusModalMensagem = () =>
				dispatch(commonActions.mudarStatusModalMensagem(true, null));
			const history = props.history;
			const states = {
				...payload,
				modalCertificacaoDigital,
				mudarStatusModalMensagem,
				history,
			};

			let navIcones = GetNavIcones(states, messages);

			if (!acessoPermitido(usuario, acessos.ConsultaDescarteMateriais)) {
				navIcones.splice(
					navIcones.findIndex((lst) => lst.id === 3),
					1
				);
			}

			if (detalhes && !detalhes.habilitadoCertificacao) {
				navIcones.splice(
					navIcones.findIndex((lst) => lst.id === 2),
					1
				);
			}

			if (res.integracaoMV) {
				navIcones.splice(
					navIcones.findIndex((lst) => lst.id === 7),
					1
				);
			}

			navIcones = navIcones.filter((lst) => {
				if (lst.id === 2) {
					lst.onClick = (e) => {
						op.current.toggle(e);
						dispatch(certificacaoActions.certificadosSelecionados([]));
						dispatch(certificacaoActions.listaPendentes([]));
						dispatch(certificacaoActions.listaExibido(0));
						getCertificadosPendentes();
					};
				} else if (lst.id === 5) {
					lst.onClick = (e) => {
						e && soul.current.toggle(e);
						dispatch(commonActions.modalSoul(!modalSoul));
					};
				} else if (lst.id === 6) {
					lst.onClick = (e) => {
						e && refServiceAgreement.current.toggle(e);
					};
				} else if (lst.id === 7) {
					lst.onClick = (e) => {
						setOpenModalNovoPedido(!openModalNovoPedido);
					};
				}
				return lst;
			});

			if (payload.links && !payload.links.casLogin) {
				navIcones = navIcones.filter((x) => x.id !== 5);
			}

			navIcones.length > 0 && setNavIcones(navIcones);
		});
	}

	function getCounts() {
		var requests = [];
		const payloadCertificados = {
			numeroPagina: paginaCertificado,
			quantidadePagina: 5,
		};
		requests.push(DescarteApi.totalItemsDescarte());
		requests.push(WebapiCommon.getTotalMensagens(usuario.usuarioId));
		requests.push(WebapiCommon.getCertificadosPendentes(payloadCertificados));
		requests.push(ConfiguracaoApi.getConfiguracaoLogin());

		Promise.all(requests).then((result) => {
			const descarte = result[0];
			const mensagens = result[1];
			const certificados = result[2];
			const links = result[3];

			//Descate
			let quantidade = descarte.quantidade;
			let count = quantidade !== 0 && quantidade !== '0' ? quantidade : '';
			dispatch(descarteActions.totalMateriaisavencer(count));
			//dispatch(descarteActions.dataInicio(descarte.dataInicio));
			//dispatch(descarteActions.dataFim(descarte.dataFim));
			dispatch(descarteActions.filtroValue('dtvencimento'));
			//Mensagens
			dispatch(commonActions.preencherTotalMensagens(mensagens));
			dispatch(
				commonActions.setTimeoutTotalMensagens(
					setTimeout(() => {
						getTotalMensagens(usuario.usuarioId);
					}, 900000)
				)
			);
			//Certificados
			let pageCert = paginaCertificado;
			if (totalCertificadosPendentes > 5) {
				pageCert = pageCert + 1;
			}
			if (listaCertificadosPendentes.length > 0 && certificados.length > 0) {
				const novaLista = listaCertificadosPendentes;
				certificados.forEach((element) => {
					if (
						listaCertificadosPendentes
							.map((x) => x.laudo)
							.indexOf(element.laudo) < 0
					) {
						novaLista.push(element);
					}
				});
				dispatch(certificacaoActions.listaPendentes(novaLista));
				dispatch(certificacaoActions.listaExibido(novaLista.length));
				dispatch(certificacaoActions.pagina(pageCert));
			} else if (certificados.length > 0) {
				dispatch(certificacaoActions.listaPendentes(certificados));
				dispatch(certificacaoActions.listaExibido(certificados.length));
				dispatch(certificacaoActions.pagina(pageCert));
			}

			const payload = {
				totalCertificadosPendentes: certificados.length,
				totalMateriaisavencer: count,
				totalMensagens: mensagens,
				quantAcordos: countAcordo,
				links,
			};

			setLinkSoul(links);
			verificaPermissao(payload);
		});
	}

	function getTotalMensagens(usuarioId) {
		WebapiCommon.getTotalMensagens(usuarioId).then((result) => {
			dispatch(commonActions.preencherTotalMensagens(result));
			dispatch(
				commonActions.setTimeoutTotalMensagens(
					setTimeout(() => {
						getTotalMensagens(usuarioId);
					}, 900000)
				)
			);
		});
	}

	function selectItem(item) {
		const draft = [...certificadosSelecionados];
		const index = draft.indexOf(item);
		if (index >= 0) {
			draft.splice(index, 1);
		} else {
			draft.push(item);
		}
		dispatch(certificacaoActions.certificadosSelecionados(draft));
	}

	function resetCertificadosPendentes() {
		const payload = {
			numeroPagina: 1,
			quantidadePagina: 5,
		};
		WebapiCommon.getCertificadosPendentes(payload).then((result) => {
			dispatch(certificacaoActions.listaPendentes(result));
			dispatch(certificacaoActions.listaExibido(result.length));
			dispatch(certificacaoActions.pagina(2));
		});
	}

	function getCertificadosPendentes() {
		const payload = {
			numeroPagina: paginaCertificado,
			quantidadePagina: 5,
		};
		WebapiCommon.getCertificadosPendentes(payload)
			.then((result) => {
				let page = paginaCertificado;
				if (totalCertificadosPendentes > 5) {
					page = page + 1;
				}
				if (listaCertificadosPendentes.length > 0 && result.length > 0) {
					const lista = listaCertificadosPendentes;
					result.forEach((element) => {
						if (
							listaCertificadosPendentes
								.map((x) => x.laudo)
								.indexOf(element.laudo) < 0
						) {
							lista.push(element);
						}
					});
					dispatch(certificacaoActions.listaPendentes(lista));
					dispatch(certificacaoActions.listaExibido(lista.length));
					dispatch(certificacaoActions.pagina(page));
				} else if (result.length > 0) {
					dispatch(certificacaoActions.listaPendentes(result));
					dispatch(certificacaoActions.listaExibido(result.length));
					dispatch(certificacaoActions.pagina(page));
				}
			})
			.catch((err) => {
				console.log(err);
			});
	}

	function verificaStatusLabel(cod) {
		if (cod === 0) {
			return 'Certificado';
		} else if (cod > 899 && cod < 1000) {
			return 'Em Processo';
		} else {
			return 'Error';
		}
	}

	function verificaStatusColor(cod) {
		if (cod === 0) {
			return 'success';
		} else if (cod > 899 && cod < 1000) {
			return 'warning';
		} else {
			return 'danger';
		}
	}

	function verifyProtocol(link) {
		if (link.includes('http')) {
			return link;
		} else {
			return 'http://' + link;
		}
	}

	const NotificationItem = ({
		laudo,
		pacienteNome,
		exameNome,
		status,
		codStatus,
		dataEnvioCertificacao,
	}) => {
		return (
			<div
				id={laudo}
				className="d-flex flex-row mb-3 pb-3 border-bottom card-certificate"
				data={certificadosSelecionados.indexOf(laudo) >= 0 ? 'active' : ''}
				onClick={() => selectItem(laudo)}
			>
				<div className="row" style={{ width: '100%' }}>
					<div className="col-10">
						<p className="font-weight-medium mb-1">
							<strong>
								<IntlMessage id="dashboards.examDetails.laud" />{' '}
							</strong>{' '}
							<span>{laudo}</span>
						</p>
						<p className="text-muted mb-0 text-small">
							<strong>
								<IntlMessage id="dashboards.examDetail.patient" />
							</strong>{' '}
							<span>{pacienteNome}</span>
						</p>
						<p className="text-muted mb-0 text-small">
							<strong>
								<IntlMessage id="dashboards.examDetails.exam" />{' '}
							</strong>
							<span>{exameNome}</span>
						</p>
						<p className="text-muted mb-0 text-small">
							<strong>
								<IntlMessage id="dashboards.examDetails.shippingDate" />
							</strong>{' '}
							<span>{dataEnvioCertificacao}</span>
						</p>
					</div>

					<div className="col-2" id={'certificado_' + laudo}>
						<Badge color={verificaStatusColor(codStatus)}>
							{verificaStatusLabel(codStatus)}
						</Badge>
					</div>

					<UncontrolledTooltip placement="top" target={'certificado_' + laudo}>
						{status}
					</UncontrolledTooltip>
				</div>
			</div>
		);
	};

	function certificarSelecionados() {
		const laudos = [];
		const doc = document.getElementsByClassName('card-certificate');
		for (let index = 0; index < doc.length; index++) {
			const element = doc[index];
			if (element.getAttribute('data') === 'active') {
				laudos.push(Number(element.id));
			}
		}
		dispatch(certificacaoActions.certificadosSelecionados(laudos));
		dispatch(certificacaoActions.showModal(!modalCertificacaoDigital));
	}

	const handleScroll = () => {
		getCertificadosPendentes();
	};

	useEffect(() => {
		if (usuario !== null ) {
			getCounts();
		}
	}, [usuario, countAcordo]);

	useEffect(() => {
		function getTotalCertificadosPendentes() {
			WebapiCommon.getTotalCertificadosPendentes().then((result) => {
				dispatch(certificacaoActions.totalPendentes(result));
				let _navIcones = navIcones;
				_navIcones.map(
					(x) => x.id === 2 && { ...x, badge: totalCertificadosPendentes }
				);
				_navIcones.length && setNavIcones(_navIcones);
			});
		}
		getTotalCertificadosPendentes();
	}, [totalCertificadosPendentes]);

	useEffect(() => {
		if (!currentUser || !currentUser.usuarioId) {
			const user = userVerify();
			if (!user || !user.usuarioId) {
				logout();
			} else {
				setUsuario(user);
			}
		} else {
			setUsuario(currentUser);
		}
	}, [currentUser]);

	useEffect(() => {
		let _navIcones = navIcones;
		_navIcones.map(
			(x) => x.id === 3 && { ...x, badge: currentTotalMateriaisavencer }
		);
		_navIcones.length && setNavIcones(_navIcones);
	}, [currentTotalMateriaisavencer]);

	useEffect(() => {
		if (listagemExibido === totalCertificadosPendentes) {
			return;
		}
		scrolled && listaCertificadosPendentes.length > 0 && handleScroll();
		setScrolled(false);
	}, [scrolled, listaCertificadosPendentes]);

	useEffect(() => {
		const checkScroll = (_) => {
			if (listagemExibido === totalCertificadosPendentes) {
				return setScrolled(false);
			}
			if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
				setScrolled(true);
			} else {
				setScrolled(false);
			}
		};
		const listElm = document.querySelector('#infinite-list');
		listElm && listElm.addEventListener('scroll', checkScroll);
		return (_) => {
			listElm && listElm.removeEventListener('scroll', checkScroll);
		};
	}, [scrolled, listaCertificadosPendentes]);

	const [periodStart, setPeriodStart] = useState('');
	const [periodEnd, setPeriodEnd] = useState('');
	const [period, setPeriod] = useState('');
	const [periodConfirm, setPeriodConfirm] = useState('');

	function resetPeriods() {
		setPeriodConfirm('');
		setPeriodStart('');
		setPeriodEnd('');
		setPeriod(1);
	}

	function changeIntervalPeriod(val) {
		const period = changePeriod(val);
		setPeriodStart(period.start);
		setPeriodEnd(period.end);
	}

	function periodChanged(e) {
		if (!e || !e.value) {
			return resetPeriods();
		}
		const customPeriodo = e.value;
		const payload = getDate(customPeriodo);
		if (payload.dtinicial) {
			setPeriodStart(payload.dtinicial.toISOString().slice(0, 10));
		}
		if (payload.dtfinal) {
			setPeriodEnd(payload.dtfinal.toISOString().slice(0, 10));
		}

		setPeriod(periods.find((x) => x.value === customPeriodo));
	}

	const onStatusFilterChange = (event) => {
		dt.current.filter(event.value, 'status', 'equals');
		setSelectedStatus(event.value);
	};

	const statuses = ['vencido', 'atrasado', 'em_dia'];

	const renderStatusFilter = () => {
		return (
			<Dropdown
				value={selectedStatus}
				options={statuses}
				onChange={onStatusFilterChange}
				itemTemplate={statusItemTemplate}
				showClear={true}
				placeholder="Selecione um"
				className="p-column-filter"
			/>
		);
	};

	const [formattedStatusFilter, setformattedStatusFilter] = useState('');

	const statusItemTemplate = (option) => {
		if (option === 'em_dia') {
			setformattedStatusFilter('Em Dia');
		}
		return (
			<span className={classNames('customer-badge', 'status-' + option)}>
				{option === 'em_dia' ? formattedStatusFilter : option}
			</span>
		);
	};

	const [formattedStatus, setformattedStatus] = useState('');

	const statusBodyTemplate = (rowData) => {
		if (rowData.status === 'em_dia') {
			setformattedStatus('Em Dia');
		}

		return (
			<span
				className={classNames('customer-badge', 'status-' + rowData.status)}
			>
				{rowData.status === 'em_dia' ? formattedStatus : rowData.status}
			</span>
		);
	};

	const renderDateFilter = () => {
		return (
			<DatePicker
				isClearable
				locale="pt-br"
				dateFormat="dd/MM/yyyy"
				selected={selectedData}
				onChange={(e) => {
					if (e) {
						setSelectedData(e);
						dt.current.filter(
							new Date(e).toLocaleDateString(),
							'dt_acordo',
							'contains'
						);
					} else {
						setSelectedData(undefined);
						dt.current.filter('', 'dt_acordo', 'contains');
					}
				}}
				maxDate={new Date()}
			/>
		);
	};

	const renderDateFilterVencimento = () => {
		return (
			<DatePicker
				isClearable
				locale="pt-br"
				dateFormat="dd/MM/yyyy"
				selected={selectedDataVencimento}
				onChange={(e) => {
					if (e) {
						setSelectedDataVencimento(e);
						dt.current.filter(
							new Date(e).toLocaleDateString(),
							'dt_vencimento',
							'contains'
						);
					} else {
						setSelectedDataVencimento(undefined);
						dt.current.filter('', 'dt_vencimento', 'contains');
					}
				}}
			/>
		);
	};

	const statusFilter = renderStatusFilter();
	const dateFilterEl = renderDateFilter();
	const dateFilterElVencimento = renderDateFilterVencimento();

	const dataBody = (prop) => (
		<div className="date-order">
			{prop ? prop.dt_acordo : <React.Fragment></React.Fragment>}
		</div>
	);

	const dataBodyVencimento = (prop) => (
		<div className="date-order">
			{prop ? prop.dt_vencimento : <React.Fragment></React.Fragment>}
		</div>
	);

	function filtrar() {
		const payload = [
			{
				param: 'Laudos',
				value: selectedServiceAgreement.map((x) => x.id_Exame_pedido),
			},
		];

		dispatch(commonActions.preencherFiltroExterno(payload));
		refServiceAgreement.current.hide();
	}

	return (
		<div className="topnav">
			<div className="mv-nav-left menu-principal">
				<i
					className={collapsed ? 'mv-basico-menu' : 'mv-basico-fechar'}
					onClick={() => {
						dispatch(actions.estadoMenuLateral(!collapsed));
					}}
				></i>
			</div>
			<NavComponent
				{...props}
				titulo="Anatomia"
				desc="Patológica"
				logo={Logo}
				icones={navIcones}
				usuario={usuario && usuario.usuario}
				onLogoutClick={() => logout()}
			/>

			<ModalCertificacao
				laudos={certificadosSelecionados}
				isOpen={modalCertificacaoDigital}
				onModal={(e) => {
					dispatch(certificacaoActions.showModal(!modalCertificacaoDigital));
				}}
				onSuccess={() => resetPendentes()}
			/>

			<ModalNovoPedido
				intl={props.intl}
				isOpen={openModalNovoPedido}
				setOpenModalNovoPedido={setOpenModalNovoPedido}
			/>

			<OverlayPanel
				ref={(el) => (op.current = el)}
				showCloseIcon={false}
				dismissable={false}
				id="overlay_panel"
				style={{
					width: '470px',
					maxHeight: '80vh',
				}}
				className="overlaypanel"
			>
				{!listagemExibido && (
					<Col className="mv-listagem-container no-result">
						<IntlMessage id="dashboards.examDetails.noPendingCertificates" />
					</Col>
				)}
				<div
					style={{
						maxHeight: 500,
						overflowX: 'hidden',
						overflowY: 'auto',
						display: 'flex',
						flexDirection: 'column',
					}}
					id="infinite-list"
				>
					{listagemExibido > 0 &&
						listaCertificadosPendentes.map((notification, index) => {
							return <NotificationItem key={index} {...notification} />;
						})}

					{listagemExibido > 0 &&
						acessoPermitido(usuario, acessos.CertificacaoDigital) && (
							<div className="mb-3">
								<Button
									onClick={() => certificarSelecionados()}
									color="primary"
									disabled={certificadosSelecionados.length <= 0}
								>
									<IntlMessage id="dashboards.examDetails.certifySelection" />
								</Button>
								<Button
									onClick={() => {
										dispatch(certificacaoActions.certificadosSelecionados([]));
										dispatch(
											certificacaoActions.showModal(!modalCertificacaoDigital)
										);
									}}
									className="ml-3"
									color="secondary"
								>
									<IntlMessage id="dashboards.examDetails.certifyAll" />
								</Button>
								<br />
							</div>
						)}
				</div>
			</OverlayPanel>

			<OverlayPanel
				ref={(el) => (soul.current = el)}
				showCloseIcon={false}
				dismissable={false}
				id="overlay_links"
				style={{
					width: '300px',
					marginLeft: '-275px',
					maxHeight: '80vh',
				}}
				className="overlaypanel"
			>
				<div className="soul">
					{linkSoul && (
						<ul>
							<li>
								<a
									href={verifyProtocol(
										linkSoul && linkSoul.urlCas ? linkSoul.urlCas : ''
									)}
									target="_blank"
								>
									{messages['link.integratesoul.cas']}
								</a>
							</li>
							<li>
								<a
									href={verifyProtocol(
										linkSoul && linkSoul.urlPep ? linkSoul.urlPep : ''
									)}
									target="_blank"
								>
									{messages['link.integratesoul.pep']}
								</a>
							</li>
						</ul>
					)}
				</div>
			</OverlayPanel>
			<OverlayPanel
				className="overlaypanel-over"
				dismissable
				ref={dateRef}
				style={{ width: '300px' }}
			>
				<Row className="filters">
					<Colxx xl={12}>
						<div className="form-group has-float-label">
							<label>
								<IntlMessage id="period.name" />
							</label>
							<Select
								isClearable
								className="react-select"
								classNamePrefix="react-select"
								name="form-field-period"
								placeholder={messages['period.all']}
								value={period}
								onChange={(e) => {
									periodChanged(e);
									e && e.value
										? changeIntervalPeriod(e.value)
										: changeIntervalPeriod('todos');
								}}
								options={periods}
								menuPortalTarget={document.getElementsByTagName('main')[0]}
								styles={{
									minWidth: '300px',
									menuPortal: (base) => ({ ...base, zIndex: 9999 }),
								}}
							/>
						</div>
					</Colxx>

					{period && period.value === 'outro' && (
						<React.Fragment>
							<Colxx xl={6}>
								<div className="mb-2" id={'filter-date'}>
									<div className="form-group has-float-label">
										<label>
											<IntlMessage id="period.datestart" />
										</label>
										<DatePicker
											locale="pt-br"
											dateFormat="dd/MM/yyyy"
											selected={periodStart ? new Date(periodStart) : ''}
											onChange={(e) => {
												setPeriodStart(e);
											}}
											maxDate={new Date()}
										/>
									</div>
								</div>
							</Colxx>
							<Colxx xl={6}>
								<div className="mb-2">
									<div className="form-group has-float-label">
										<label>
											<IntlMessage id="period.dateend" />
										</label>
										<DatePicker
											locale="pt-br"
											dateFormat="dd/MM/yyyy"
											selected={periodEnd ? new Date(periodEnd) : ''}
											onChange={(e) => setPeriodEnd(e)}
											minDate={new Date(periodStart)}
											maxDate={new Date()}
										/>
									</div>
								</div>
							</Colxx>
						</React.Fragment>
					)}
				</Row>
				<Separator className="mb-3" />
				<Row>
					<PrimeButton
						label={messages['dashboards.examDetail.close']}
						icon="pi pi-times"
						color="Secondary"
						onClick={(e) => {
							dateRef && dateRef.current.hide();
						}}
						className="p-button-secondary p-button-text ml-3 col-4 mr-6"
					/>
					<PrimeButton
						className=" ml-2 col-5"
						label={messages['dashboards.examDetails.confirm']}
						icon="pi pi-check"
						onClick={(e) => {
							dateRef && dateRef.current.hide();
							setPeriodConfirm(period.label);
						}}
						autoFocus
					/>
				</Row>
			</OverlayPanel>
			<OverlayPanel
				ref={(el) => (refServiceAgreement.current = el)}
				showCloseIcon={false}
				dismissable={false}
				id="overlay_links"
				// style={{ width: '834px' }}
				style={{ maxWidth: '834px', maxHeight: '700px' }}
				className="overlaypanel"
			>
				<div
					className="vivace-datatable"
					style={{ maxHeight: 'calc(100vh - 245px)', overflowY: 'auto' }}
				>
					<DataTable
						ref={dt}
						value={serviceAgreement}
						header={header}
						responsive
						className="p-datatable-customers"
						dataKey="id_Exame_pedido"
						rowHover
						selection={selectedServiceAgreement}
						onSelectionChange={(e) => setSelectedServiceAgreement(e.value)}
						paginator
						rows={8}
						pageLinkSize={5}
						emptyMessage={messages['messages.notdata']}
						currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
						paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
					>
						<Column selectionMode="multiple" style={{ width: '3em' }} />

						<Column
							field="id_Exame_pedido"
							header="Laudo"
							sortable
							filter
							filterPlaceholder="Por laudo"
						></Column>
						<Column
							field="nr_exame"
							header="Nr Exame"
							sortable
							filter
							filterPlaceholder="Por exame"
						></Column>
						<Column
							filterMatchMode="custom"
							field="dt_acordo"
							header="Data do Pedido"
							sortable
							filter
							filterElement={dateFilterEl}
							body={dataBody}
						></Column>
						<Column
							filterMatchMode="custom"
							field="dt_vencimento"
							header="Data do Vencimento"
							sortable
							filter
							filterElement={dateFilterElVencimento}
							body={dataBodyVencimento}
						></Column>
						<Column
							field="status"
							header="Situação"
							body={statusBodyTemplate}
							sortable
							filter
							filterElement={statusFilter}
						></Column>
					</DataTable>

					<div className="row mt-2 col-12 ">
						<div className="col-12">
							<Button
								disabled={
									!selectedServiceAgreement ||
									selectedServiceAgreement.length === 0
								}
								block
								color="primary"
								onClick={() => filtrar()}
							>
								Pesquisar
							</Button>
						</div>
					</div>
				</div>
			</OverlayPanel>
			{modalMensagens && <MensagensContainer />}
			{hml && (
				<div className="mv-ambiente-hml">
					<IntlMessage id="dashboards.general.approvalEnvironment" />
				</div>
			)}
		</div>
	);
};

export default injectIntl(TopNav);



// WEBPACK FOOTER //
// ./src/componentes/nav/nav.component.js